import {
  BackupShelfItem,
  BrowserMessageResponse,
  BrowserMessageType,
  exchangeElectronMessage,
  sendElectronMessage,
} from 'electron-communication-lib/BrowserForApp';
import {useEffect, useRef, useState} from 'react';

import i18n from '_/i18n';
import {showSimpleConfirmationDialog} from '_/sharedComponents/ConfirmationDialog';

export const useBackupShelfFiles = ({
  onOpen,
}: {
  onOpen: () => void;
}): BackupShelfItem[] => {
  const [filesList, setFilesList] = useState<BackupShelfItem[]>([]);
  const fileListRef = useRef<BackupShelfItem[]>([]);

  useEffect(() => {
    let id = 0;
    id = window.setInterval(() => {
      exchangeElectronMessage(
        {
          type: BrowserMessageType.BACKUP_SHELF_GET_FILES,
          payload: null,
        },
        (
          response: BrowserMessageResponse[BrowserMessageType.BACKUP_SHELF_GET_FILES]
        ) => {
          if (shouldBeOpened(fileListRef.current, response)) {
            onOpen();
          }
          const files = response.sort(
            (a, b) => b.lastModifiedAt - a.lastModifiedAt
          );
          setFilesList(files);
          fileListRef.current = files;
        }
      );
      // poll the files every 0.75 seconds, this should feel snappy enough
    }, 750);
    // remove interval when new effect gets triggered
    return () => (id ? clearInterval(id) : undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return filesList;
};

const shouldBeOpened = (
  currentFileList: BackupShelfItem[],
  newFileList: BackupShelfItem[]
): boolean => {
  // Open on new files
  const fileNames = currentFileList.map((file) => file.fileName);
  return newFileList.some(({fileName}) => !fileNames.includes(fileName));
};

export const showDeleteConfirmationDialog = (
  filesToDelete: BackupShelfItem[]
): void => {
  const hasManyToDelete = filesToDelete.length > 1;
  showSimpleConfirmationDialog({
    headerText: hasManyToDelete
      ? i18n.t('documents:backupShelf.deleteConfirmation.many.headerText')
      : i18n.t('documents:backupShelf.deleteConfirmation.one.headerText'),
    message: hasManyToDelete
      ? i18n.t('documents:backupShelf.deleteConfirmation.many.message')
      : i18n.t('documents:backupShelf.deleteConfirmation.one.message'),
    onConfirmed: () => {
      sendElectronMessage({
        payload: filesToDelete.map(({path}) => path),
        type: BrowserMessageType.BACKUP_SHELF_DELETE_FILES,
      });
    },
    buttonProps: {
      confirmationButtonText: i18n.t(
        'documents:backupShelf.deleteConfirmation.confirmationButtonText'
      ),
    },
  });
};
